import { showBundlePlanModal } from "./showBundlePlanModal"
import { showConfirmModal } from "./showConfirmModal"
import { showConfirmModalBeforeLeave } from "./showConfirmModalBeforeLeave"
import { showCWPlanModal } from "./showCWPlanModal"
import { showDeleteModal } from "./showDeleteModal"
import { showDowngradeModal } from "./showDowngradeModal"
import { showSchemaFormModal } from "./showSchemaFormModal"
import { showUpgradeModal } from "./showUpgradeModal"
import { showUpgradeModalByBenefits } from "./showUpgradeModalByBenefits"
export {
  showConfirmModal,
  showConfirmModalBeforeLeave,
  showDeleteModal,
  showUpgradeModal,
  showUpgradeModalByBenefits,
}

export const PModal = {
  showConfirmModal,
  showConfirmModalBeforeLeave,
  showDeleteModal,
  showSchemaFormModal,
  showUpgradeModal,
  showCWPlanModal,
  showBundlePlanModal,
  showDowngradeModal,
  showUpgradeModalByBenefits,
} as const
